export const PERMISSION_SUPER_ADMIN_NAME = 'Super Admin';
